import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=3804650f&scoped=true"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=3804650f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3804650f",
  null
  
)

export default component.exports